// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteModal_bi__e112w {
  display: flex;
  margin-top: 15rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Inventory/DeleteModal.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,iBAAA;AADD","sourcesContent":["@import '../variables/breakpoints';\n\n.bi {\n\tdisplay: flex;\n\tmargin-top: 15rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bi": `DeleteModal_bi__e112w`
};
export default ___CSS_LOADER_EXPORT___;
